module.exports = __webpack_public_path__ + "img/TB.cc38d146.svg";